export default {
    name:'money',
    format: (v) => {
        return v ? Number(v).toFixed(2) : '0.00'
    }
}